import { jsx as u } from "@emotion/react/jsx-runtime";
import { useState as s, useEffect as S } from "react";
import { STATIC_COVERS_ASSET as a, STATIC_FALLBACK_ASSET as c } from "../../utils/constants.js";
import { FullSizeIllustration as g } from "./Cover.styled.js";
const C = ({
  cover: e,
  className: l
}) => {
  const t = `${a}/${e.type}/${e.name}.svg`, n = `${c}/cover/not_found.svg`, [i, o] = s(!1), [f, m] = s(300);
  return S(() => {
    const r = new Image();
    r.src = t, r.onload = () => {
      o(!1), m(r.height);
    }, r.onerror = () => {
      o(!0);
    };
  }, [t]), /* @__PURE__ */ u(g, { className: l, url: i ? n : t, height: f });
};
export {
  C as Cover
};
